import { useStaticQuery, graphql } from "gatsby"

const useLogos = () => {
  const logos = useStaticQuery(graphql`
    query LogosQuery {
      groupLogo: file(relativePath: { eq: "gba-group-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 60, placeholder: NONE)
        }
      }
      foodLogo: file(relativePath: { eq: "gba-food-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 60, placeholder: NONE)
        }
      }
      pharmaLogo: file(relativePath: { eq: "gba-life-science-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 60, placeholder: NONE)
        }
      }
      environmentLogo: file(relativePath: { eq: "gba-environment-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 60, placeholder: NONE)
        }
      }
      cosmeticsLogo: file(relativePath: { eq: "gba-life-science-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 60, placeholder: NONE)
        }
      }
      agroChemicalLogo: file(
        relativePath: { eq: "gba-life-science-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 60, placeholder: NONE)
        }
      }
      medicalLogo: file(relativePath: { eq: "gba-life-science-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 60, placeholder: NONE)
        }
      }
      lifeScienceLogo: file(relativePath: { eq: "gba-life-science-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 60, placeholder: NONE)
        }
      }
      veterinaryLogo: file(relativePath: { eq: "gba-veterinary-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 60, placeholder: NONE)
        }
      }
    }
  `)

  return logos
}

export { useLogos }
